module.exports = __webpack_public_path__ + "static/img/check_type_3.a20cb76d.png";